import { MQ_SMALL_ONLY, MQ_LARGE, MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base3x2, medium3x2, medium4x5, large3x2 } = IMAGE_SIZES;

const base = {
  fallbackDims: base3x2,
  sourceSets: [
    {
      layoutWidth: { value: 1148, units: 'px' },
      imageDims: large3x2,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 976, units: 'px' },
      imageDims: medium3x2,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 720, units: 'px' },
      imageDims: large3x2,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 320, units: 'px' },
      imageDims: medium4x5,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: MQ_MEDIUM,
      ratio: 3 / 2
    },
    {
      media: MQ_SMALL_ONLY,
      ratio: 4 / 5
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
